<template>
  <div class="live2d-tab" :class="{ active: allTabItems.length >= 11 }" v-if="allTabItems.length">
    <div class="scroll-wrapper" ref="scroll">
      <div class="scroll-content">
        <div
          class="tab-item"
          :class="{ active: activeIndex === index }"
          v-for="(item, index) in allTabItems"
          :key="item.uniqueKey"
          @click="changeLive2d(item.type, item.key, index)"
        >
          <div class="item-text">{{ item.displayName }}</div>
          <img :src="item.backgroundImage" alt="" class="img-btn" />
          <img src="@/assets/zs_imgs/honor-icon.png" alt="" class="honor-img" v-if="item.type === 'honorLive2d'" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BScroll from "@better-scroll/core";

export default {
  name: "Live2dTab",
  props: {
    currentStyle: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    allTabItems: {
      handler() {
        this.$nextTick(() => {
          if (this.bs) {
            this.bs.destroy();
          }
          this.$nextTick(() => {
            this.initBS();
          });
        });
      },
      immediate: true
    }
  },
  computed: {
    allTabItems() {
      const items = [];
      let index = 0;
      const addItems = (sourceObj, imgObj, type, extraFilter = () => true) => {
        if (!sourceObj) return;
        Object.keys(sourceObj).forEach(key => {
          const config = sourceObj[key];
          let idx = "";
          if (["cg_source1", "cg_source2", "cg_source3", "cg_source4"].includes(key)) {
            idx = key.split("cg_source")[1];
          }
          if (config.value && config.hasValue && extraFilter(key)) {
            items.push({
              type,
              key,
              uniqueKey: `${type}-${key}-${index}`,
              backgroundImage: idx ? imgObj?.[`cg_sourceImg${idx}`]?.value : imgObj?.[`${key}Img`]?.value || "",
              displayName: this.getDisplayName(key)
            });
            index++;
          }
        });
      };
      addItems(this.currentStyle.live2d, this.currentStyle.live2dImg, "live2d", key => key !== "lh");
      addItems(this.currentStyle.honorLive2d, this.currentStyle.honorLive2dImg, "honorLive2d");
      return items;
    }
  },
  data() {
    return {
      textMap: {
        source: "立绘",
        jh_source: "互动",
        jn_source: "技能",
        cg_source: "剧情",
        cg_source1: "剧情",
        cg_source2: "剧情",
        cg_source3: "剧情",
        cg_source4: "剧情"
      },
      bs: null,
      activeIndex: 0
    };
  },
  methods: {
    initBS() {
      if (!this.$refs.scroll) return;
      this.bs = new BScroll(this.$refs.scroll, {
        scrollX: true,
        probeType: 3
      });
    },
    getDisplayName(key) {
      return this.textMap[key] || key;
    },
    changeLive2d(type, key, index) {
      this.activeIndex = index;
      this.$emit("onChangeLive2d", { type, key });
    }
  }
};
</script>
<style scoped lang="less">
.live2d-tab {
  //width: 306px;
  //overflow: hidden;
  height: 60px;
  display: flex;
  column-gap: 14px;
  z-index: 1000;

  &.active {
    //&::after {
    //  position: absolute;
    //  bottom: 0;
    //  right: 0;
    //  display: inline-block;
    //  content: "";
    //  width: 30px;
    //  height: 50px;
    //  background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
    //  z-index: 1001;
    //}
  }

  .scroll-wrapper {
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
  }

  .scroll-content {
    display: inline-block;
    height: 100%;
  }

  .tab-item {
    position: relative;
    bottom: -10px;
    margin-right: 14px;
    display: inline-block;
    flex-shrink: 0;
    width: 50px;
    height: 50px;
    cursor: pointer;
    background-size: cover;
    border-radius: 2px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: #e3e3e3;

    &.active {
      border: 1px solid rgba(255, 255, 252, 1);
      box-shadow: inset 0px 0px 4px 0px rgba(255, 230, 66, 1), 0px 0px 4px 0px rgba(255, 234, 128, 1);
    }

    .item-text {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      background: rgba(0, 0, 0, 0.5);
      text-align: center;
      color: #fff;
      font-size: 12px;
      z-index: 12;
    }

    .img-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center top;
      border-radius: 2px;
      z-index: 10;
    }

    .honor-img {
      width: 20px;
      height: 20px;
      position: absolute;
      top: -10px;
      left: -10px;
      z-index: 11;
    }
  }
}
</style>
